import { get } from 'app/utils/axios/kheti'
import {Crop, SowingRecord} from '../models/crop'

const fetchFarmerOngoingCrops = async (farmerId: string) => {
  try {
    const url = `/farmer-360/v1/farmer/${farmerId}/ongoing-crops`
    const response = await get<SowingRecord[]>(url)

    return Object.entries(response)
        .filter(([key]) => key !== "api-trace-id")
        .map(([, value]) => value) as SowingRecord[];
  } catch (e) {
    return []
  }
}

export default fetchFarmerOngoingCrops
